module.exports = __webpack_public_path__ + "img/emoji_44.7d7be6d3.png";